module.exports = __webpack_public_path__ + "529015398751cce3c26b0490d1bf3e5c.svg";